import { Button } from '@platform/components';
import { useEffect, useState } from 'react';
import { LogInBackground } from '../components/LogInBackground';
import { ApplicationStartShowcasePro } from './ApplicationStartShowcasePro';
import { ApplicationStartShowcaseRep } from './ApplicationStartShowcaseRep';

export const PROGRAM_NAMES: Record<string, string> = {
  f5: 'Volunteer Sprint',
  lumen: 'Lumen Cares Volunteer Sprints',
  reckitt: 'Accelerate Hub',
  philips: 'Philips Foundation Skilled Volunteering',
};

export const ApplicationStartPage = () => {
  const [isRep, setIsRep] = useState(false);
  const [partner, setPartner] = useState<string | null>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get('is_rep') === 'true') {
      setIsRep(true);
    }
    if (searchParams.get('partner')) {
      setPartner(searchParams.get('partner'));
    }
  }, []);

  const onPressContinue = () => {
    let path = 'individual';
    if (isRep) {
      path = 'organization';
    }
    if (partner) {
      path = `${partner}`;
    }
    window.location.href = `/platform/application/${path}`;
  };

  const displayCustomWelcome = ['f5', 'lumen', 'reckitt', 'philips'].includes(
    partner?.toLowerCase() || '',
  );

  return (
    <LogInBackground
      customBackground={isRep ? <ApplicationStartShowcaseRep /> : <ApplicationStartShowcasePro />}
    >
      <div className='h-full'>
        <div className='flex flex-col w-full md:h-full md:w-[400px] px-4 md:px-1 py-8 md:py-0 items-center justify-center'>
          <div className='flex flex-col gap-8'>
            <h3 className='text-display-sm font-gray-700 font-medium'>Welcome! 👋</h3>
            <div>We have a few questions to help you get started.</div>
            <div>
              It will take about {isRep ? '25' : '10'} minutes, and you can edit it later. We'll
              save as you go.
            </div>
            {displayCustomWelcome && (
              <div>
                When you're done, your {PROGRAM_NAMES[partner?.toLowerCase() || '']} lead will
                review your responses to confirm your eligibility.
              </div>
            )}
            <Button size='lg' variant='primary' onPress={onPressContinue}>
              Continue
            </Button>
          </div>
        </div>
      </div>
    </LogInBackground>
  );
};
